import { Logger } from './logger';

export function InjectLogger(tag: string = null) {
  return <T>(target: T, key: keyof T) => {
    let logger = new Logger(tag || target.constructor.name);

    Object.defineProperty(target, key, {
      get: () => logger,
      set: value => (logger = value),
      enumerable: true,
    });
  };
}
